import React from 'react';
import {
  Button,
  Col,
  Form, Modal, Row, Spinner,
} from 'react-bootstrap';
import useFluxUploadFormActions from 'utils/hooks/flux/uploadFormActions';
import TextField from 'components/DesignSystem/TextField';
import UploadAccordion from './UploadAccordion';

export default function FluxFileUploadForm() {
  const {
    form: {
      name, setName, fileRef, reset, valid,
    },
    fileNotReady,
    handleFileInput,
    verifyZipFile,
    submitStudy,
    isVerifying,
    isUploadLoading,
    modalTitle,
    modalBody,
    modalHeaderClass,
    showModal,
    setShowModal,
  } = useFluxUploadFormActions();

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Modal.Header closeButton className={modalHeaderClass}>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p style={{ whiteSpace: 'pre-line' }}>{modalBody}</p>
        </Modal.Body>
      </Modal>
      <Form>
        <Row>
          <Col>
            <Form.Group controlId="UploadFileName" className="mb-3">
              <TextField
                label="Nome do Estudo"
                type="text"
                value={name}
                onChange={(e) => { setName(e.target.value); }}
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                ref={fileRef}
                type="file"
                id="fluxFileInput"
                onChange={handleFileInput}
                className="custom-file-input mb-3"
              />
            </Form.Group>
          </Col>
        </Row>
        <UploadAccordion />
        <Row className="mt-3 d-grid gap-2">
          <Button
            onClick={verifyZipFile}
            disabled={fileNotReady || isVerifying || showModal}
          >
            {isVerifying && <Spinner animation="border" size="sm" className="me-2" />}
            Verificar Zip
          </Button>
        </Row>
        <Row className="mt-1">
          <Button
            disabled={!valid || isUploadLoading}
            onClick={submitStudy}
          >
            {isUploadLoading && <Spinner animation="border" size="sm" />}
            Enviar Estudo

          </Button>
        </Row>
        <Row>
          <Button
            variant="link"
            onClick={reset}
          >
            Cancelar Estudo
          </Button>
        </Row>
      </Form>

    </>
  );
}
